/** @deprecated */
export const USD = 'USD';
/** @deprecated */
export const EUR = 'EUR';
/** @deprecated */
export const GBP = 'GBP';
/** @deprecated */
export const AUD = 'AUD';
/** @deprecated */
export const JPY = 'JPY';
/** @deprecated */
export const SGD = 'SGD';
/** @deprecated */
export const COP = 'COP';
/** @deprecated */
export const CAD = 'CAD';
/** @deprecated */
export const INR = 'INR';